import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { UtilsService } from "src/app/services/utils.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private utils: UtilsService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Ne pas écraser un Authorization déjà posé par l'appelant : certaines
    // requêtes (ex. create-new-password depuis le lien email) portent leur
    // propre Bearer issu de l'URL, distinct du token de session.
    const token = this.utils.GetToken();
    if (token && !req.headers.has("Authorization")) {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }
    return next.handle(req);
  }
}
